import styled from 'styled-components';

export const SocialMediaContainer = styled.div`
  display: flex;
  justify-content: center;
`;
